export default __webpack_public_path__ + "static/media/Andres_Tellez.9c14e911.png";